<template>
    <section>
        <section class="w-full px-16px py-2.5 flex justify-between items-center">
            <p class="text-2xl font-bold text-skin-blueCambiando" v-text="title" />
            <icon :width="iconWidth" :height="iconHeight" :name="iconName" :color="'skin-blueCambiando'" />
        </section>
        <section class="pt-16px">
            <section class="border-t border-skin-check-box pt-16px flex flex-col md:flex-row md:justify-between px-16px md:px-8 pb-8" v-for="(item, index) in items" :key="index">
                <p class="text-lg font-bold pr-2.5 pt-7" v-text="item.title"/>
                <p class="font-medium py-2.5 lg:max-w-72.5" v-text="item.description"/>
            </section>
        </section>
    </section>
</template>
<script>
export default {
    components:{
        Icon: () => import("../components/Icon.vue"),
    },
    props:{
        title:{
            default: ''
        },
        iconName: {
            default: ''
        },
        items:{
            default: null
        },
        iconWidth:{
            default: null
        },
        iconHeight:{
            default: null
        }
    }
}
</script>